import React, { createContext, useContext, useEffect, useState } from 'react'
import { getCookie } from '@/utils/helper'
import AuthService from '@/Service/AuthService'
import { toast } from 'react-toastify'
import PagePermissionService from '@/Service/PagePermissionService'
import WorkflowService from '@/Service/WorkflowService'

const AuthContext = createContext()

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
    const storedAuthState = window.localStorage.getItem('_token')
    const [isAuthenticated, setIsAuthenticated] = useState(storedAuthState ? true : false)
    const [userInfo, setUserInfo] = useState(null)
    const [actionButton, setActionButton] = useState([])
    const [loader, setLoader] = useState(false)
    useEffect(() => {
        if (storedAuthState) {
            if (!userInfo) {
                getSession()
                getactionButton()
            }
            setIsAuthenticated(true)
        }
    }, [])

    const getSession = async () => {
        const resp = await AuthService.getSession()
        if (resp.data.success) {
            setUserInfo(resp.data.data)
        }
    }

    const getactionButton = async () => {
        const resp = await WorkflowService.getWorkflow('Work Allocation')
        if (resp.data.success) {
            setActionButton(resp.data.data.wms_workflow_table)
        }
    }
    const login = () => {
        setIsAuthenticated(true)
    }
    const logout = async () => {
        try {
            const resp = await AuthService.logout()
            if (resp.data.success) {
                window.localStorage.removeItem('_token')
                setIsAuthenticated(false)
            }
        } catch (err) {}
    }
    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, setUserInfo, userInfo, loader, setLoader, actionButton, setActionButton }}>
            {children}
        </AuthContext.Provider>
    )
}
